// Brief synopses for each chapter under Authentic Momentum: Moving from
// Struggle to Flow. Each one is short enough to land in a hover popover
// without overwhelming the reader, and written in Cyrus's voice.

export const BOOK_CHAPTERS = [
  {
    title: "Opening Frequency",
    brief:
      "Why your starting state matters more than your strategy. Setting the inner tone before you ever take action.",
  },
  {
    title: "The Linear Trap",
    brief:
      "How force, hustle, and step-by-step thinking quietly drain you, and why life never actually moves in a straight line.",
  },
  {
    title: "Frequency Before Strategy",
    brief:
      "Strategy without frequency is friction. Learn to tune your inner signal first so the outer plan stops fighting you.",
  },
  {
    title: "Intuitive Resonance",
    brief:
      "Trusting the quiet pull. How to recognize the difference between a fear-based decision and an aligned one.",
  },
  {
    title: "Energy Is the Currency",
    brief:
      "Time is not your most valuable asset. Your energy is. Where it goes, your life follows.",
  },
  {
    title: "The Visibility Principle",
    brief:
      "Being seen is not a vanity move; it is a frequency match. How alignment naturally calls in opportunity.",
  },
  {
    title: "Resistance as Signpost",
    brief:
      "Resistance is not the enemy. It is data. Read it correctly and it becomes a map back to flow.",
  },
  {
    title: "Integration",
    brief:
      "Insight without integration is just entertainment. The practices that turn a shift in awareness into a shift in life.",
  },
  {
    title: "The Continuation",
    brief:
      "Momentum is not a finish line. It is a relationship. How to keep the signal alive long after you close the book.",
  },
];
